import { Address, BitcoinNetworkType } from 'sats-connect';

import { NetworkNet } from '../common';

export const btcConnectStorage = {
  key: 'btc-connect-addresses-',
  getKey: (network: BitcoinNetworkType) => btcConnectStorage.key + network,
  getData: (network: BitcoinNetworkType) => {
    const storedData = sessionStorage.getItem(btcConnectStorage.getKey(network));

    if (!storedData) {
      return [];
    }

    try {
      const parsedData = (JSON.parse(storedData) ?? []) as Address[];

      return parsedData;
    } catch {
      return [];
    }
  },

  setData: (network: BitcoinNetworkType, data: Address[]) => {
    sessionStorage.setItem(btcConnectStorage.getKey(network), JSON.stringify(data));
  },

  clearData: () => {
    sessionStorage.removeItem(btcConnectStorage.getKey(BitcoinNetworkType.Mainnet));
    sessionStorage.removeItem(btcConnectStorage.getKey(BitcoinNetworkType.Testnet));
  },
};

export const btcNetworkToBitcoinNetworkType = (network: NetworkNet): BitcoinNetworkType => {
  switch (network) {
    case NetworkNet.Mainnet:
      return BitcoinNetworkType.Mainnet;
    case NetworkNet.Testnet:
      return BitcoinNetworkType.Testnet;
    default:
      throw new Error('Unknown BtcNetwork');
  }
};

export const bitcoinNetworkTypeToConnectorNetwork = (network: BitcoinNetworkType): 'livenet' | 'testnet' => {
  switch (network) {
    case BitcoinNetworkType.Mainnet:
      return 'livenet';
    case BitcoinNetworkType.Testnet:
      return 'testnet';
    default:
      throw new Error('Unknown BitcoinNetworkType');
  }
};
